import React from "react";
import { useRouter } from "next/router";
import styles from "./QuizNavigation.module.scss";

export default function QuizNavigation({
    currentStep,
    totalSteps,
    canContinue,
    onBack,
    onContinue,
}) {
    const { locale } = useRouter();
    const isFirst = currentStep === 0;
    const isLast = currentStep === totalSteps - 1;

    const backLabel = locale === "en" ? "Back" : "Til baka";
    const continueLabel = isLast
        ? locale === "en"
            ? "See results"
            : "Sjá niðurstöður"
        : locale === "en"
          ? "Continue"
          : "Áfram";

    return (
        <div className={styles.navRow}>
            <button
                type="button"
                className={`${styles.navBtn} ${styles.backBtn}`}
                onClick={onBack}
                disabled={isFirst}
            >
                ← {backLabel}
            </button>

            <span className={styles.stepIndicator}>
                {currentStep + 1} / {totalSteps}
            </span>

            <button
                type="button"
                className={`${styles.navBtn} ${styles.continueBtn}`}
                onClick={onContinue}
                disabled={!canContinue}
            >
                {continueLabel} →
            </button>
        </div>
    );
}
